const images = require.context('../', true, /\.(png|jpe?g|gif|svg|webp)$/);

images.keys().map(images);
